import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color  }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`] || color;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 6 18" fill="none">
  <path d="M3 1L3 17" stroke={color} stroke-linecap="round"/>
  <path d="M1 13.5361L3 17.0002" stroke={color} stroke-linecap="round"/>
  <path d="M5 13.5361L3 17.0002" stroke={color} stroke-linecap="round"/>
</svg>
  );
};
